import { MessageSquare, Search, GitBranch, Scale, Network, CheckCircle2 } from 'lucide-react';
import { useT } from '@/i18n/provider';
import { ProductFlow, type FlowStep } from './ProductFlow';

const STEPS: FlowStep[] = [
  { icon: MessageSquare, title: 'Question', sublabel: 'What happened?', accent: 'info' },
  { icon: Search, title: 'Search logs', sublabel: 'Find the errors', accent: 'info' },
  { icon: GitBranch, title: 'Check deploys', sublabel: 'Correlate changes', accent: 'primary' },
  { icon: Scale, title: 'Compare', sublabel: 'Against baseline', accent: 'warning' },
  { icon: Network, title: 'Correlate', sublabel: 'Related issues', accent: 'cyan' },
  { icon: CheckCircle2, title: 'Conclusion', sublabel: 'Root cause', accent: 'success' },
];

/** The Investigator's reasoning chain, embedded inside the home AI section. */
export function InvestigatorFlow() {
  const t = useT();
  return (
    <div className="mt-16 sm:mt-20 animate-on-scroll">
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 text-center mb-10">
        {t('aiAgent.flow.title')}
      </p>
      <ProductFlow steps={STEPS} />
    </div>
  );
}
